export const en = {
  app: {
    title: 'Lex Suite',
    subtitle: 'for Office',
  },
  auth: {
    login: 'Sign in',
    loginCta: 'Connect with Lex Suite',
    loginHint:
      'Sign in with your firm account to access documents, templates and signatures.',
    previewHint:
      "You're previewing the add-in in a browser. To actually use it, install it inside Word or Excel from Settings → Lex Suite for Office.",
    logout: 'Sign out',
    studio: 'Firm',
    selectStudio: 'Select a firm',
  },
  home: {
    documents: 'Documents',
    documentsDesc: 'Search and open firm files',
    templates: 'Contract templates',
    templatesDesc: 'Insert templates with clauses',
    clauses: 'Clause library',
    clausesDesc: 'Insert clauses by jurisdiction',
    save: 'Save to Lex',
    saveDesc: 'Upload new version to the case',
    sign: 'Sign',
    signDesc: 'Send to signature flow',
    workflow: 'Workflow',
    workflowDesc: 'Trigger case workflow',
    settings: 'Settings',
  },
  documents: {
    search: 'Search documents…',
    open: 'Open',
    empty: 'No documents found.',
  },
  templates: {
    insert: 'Insert',
    empty: 'No templates available.',
  },
  clauses: {
    jurisdiction: 'Jurisdiction',
    insert: 'Insert',
    empty: 'No clauses available.',
  },
  save: {
    cta: 'Save as new version',
    success: 'Document saved to Lex Suite',
    error: 'Could not save the document',
  },
  common: {
    loading: 'Loading…',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    error: 'An error occurred',
    retry: 'Retry',
  },
  settings: {
    language: 'Language',
    spanish: 'Spanish',
    english: 'English',
    profile: 'Profile',
  },
};
